module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/recepit-credit-grid/recepit-credit-grid.component.css
// module id = ./src/app/general-transaction/recepit-credit-grid/recepit-credit-grid.component.css
// module chunks = main